<div class="geo-filters">
  <div class="filter-section">
    <label>{{ "UPLOADED_GEO_IMAGES.FILTERS_REGION" | translate }}</label>
    <msf-tree-select
      [options]="regionOptions()"
      [model]="state.filters().regionId"
      (modelChange)="onRegionChange($event)"
      optionLabel="name"
      optionValue="id"
      treeBy="parentId"
      translateBy="none"
      [placeholder]="'UPLOADED_GEO_IMAGES.FILTERS_REGION_PLACEHOLDER' | translate"
      [showClear]="true" />
  </div>

  <div class="filter-section">
    <msf-input
      [label]="'UPLOADED_GEO_IMAGES.FILTERS_SEARCH' | translate"
      [model]="state.filters().search"
      (modelChange)="patchFilters({ search: $event })"
      (keydown.enter)="apply()"
      [placeholder]="'UPLOADED_GEO_IMAGES.FILTERS_SEARCH_PLACEHOLDER' | translate"></msf-input>
  </div>

  <div class="filter-section">
    <label>{{ "UPLOADED_GEO_IMAGES.FILTERS_CAPTURE_DATE" | translate }}</label>
    <div class="period-range">
      <app-date-picker
        [ngModel]="state.filters().captureDateFrom"
        (ngModelChange)="patchFilters({ captureDateFrom: $event })"
        [placeholder]="'UPLOADED_GEO_IMAGES.FILTERS_DATE_FROM' | translate"
        [showIcon]="true"
        [showClear]="true"
        [dateFormat]="'dd.mm.yy'"
        [maxDate]="state.filters().captureDateTo"></app-date-picker>
      <app-date-picker
        [ngModel]="state.filters().captureDateTo"
        (ngModelChange)="patchFilters({ captureDateTo: $event })"
        [placeholder]="'UPLOADED_GEO_IMAGES.FILTERS_DATE_TO' | translate"
        [showIcon]="true"
        [showClear]="true"
        [dateFormat]="'dd.mm.yy'"
        [minDate]="state.filters().captureDateFrom"></app-date-picker>
    </div>
  </div>

  <div class="filter-section">
    <app-tag-selector
      [selectedTagIds]="state.filters().tagIds"
      [label]="'UPLOADED_GEO_IMAGES.MODAL_TAGS'"
      [placeholder]="'UPLOADED_GEO_IMAGES.MODAL_TAGS_PLACEHOLDER'"
      [allowCreate]="false"
      (selectedTagIdsChange)="onTagIdsChange($event)"></app-tag-selector>
  </div>

  <div class="filter-actions">
    <app-primary-button
      width="100%"
      title="UPLOADED_GEO_IMAGES.FILTERS_APPLY"
      (action)="apply()"></app-primary-button>
    <app-secondary-button
      width="100%"
      title="UPLOADED_GEO_IMAGES.FILTERS_RESET"
      [disable]="!canReset()"
      (action)="reset()"></app-secondary-button>
  </div>

  <div class="results-count">
    {{ "UPLOADED_GEO_IMAGES.GALLERY_TOTAL" | translate: { count: state.total() } }}
  </div>
</div>
